<script setup>
import Configurator from "@components/Configurator.vue";
import WebsiteLayout from "@layouts/website-layout.vue";
import AppHead from "@layouts/sections/app-head.vue";
import {onMounted, ref} from "vue";
import { reportViewItem } from '@/Utils/Analytics';
import moment from "moment";

const props = defineProps({
    deskMaterials: Array,
    frameMaterials: Array,
    deskControllerOptions: Object,
    accessories: Array,
    desk: Object,
    baseMaterialPrice: Number,
    defaultSizes: Array
});

const jsonLDObject = ref();

if (props.desk) {
    jsonLDObject.value = {
        "@context": "https://schema.org",
        "@type": "Product",
        "productID": props.desk.mpn,
        "mpn": props.desk.mpn,
        "name": props.desk.name,
        "url": window.location.href,
        "image": [props.desk.preset_image],
        "description": props.desk.description,
        "brand": {
            "@type": "Brand",
            "name": "LevelUp Desk"
        },
        "offers": {
            "@type": "Offer",
            "priceCurrency": "EUR",
            "availability": "https://schema.org/InStock",
            "url": window.location.href,
            "price": props.desk.price,
            "priceValidUntil": moment().endOf('month').format('YYYY-MM-DD'),
            'shippingDetails': {
                '@type': 'OfferShippingDetails',
                'shippingRate': {
                    '@type': 'MonetaryAmount',
                    'value': '0',
                    'currency': 'EUR'
                },
                'shippingDestination': {
                    '@type': 'DefinedRegion',
                    'addressCountry': 'BE'
                }
            },
        },
        "shippingDetails": {
            "@type": "OfferShippingDetails",
            "shippingRate": {
                "@type": "MonetaryAmount",
                "value": "0",
                "currency": "EUR"
            },
            "shippingDestination": [
                {
                    "@type": "DefinedRegion",
                    "addressCountry": "BE"
                }
            ]
        },
        "review": {
            "@type": "Review",
            "reviewRating": {
                "@type": "Rating",
                "ratingValue": 4.8,
                "bestRating": 5
            },
            "author": {
                "@type": "Person",
                "name": "Niels De Bie"
            }
        },
        "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": 4.7,
            "reviewCount": 12
        },
    }
}

onMounted(() => {
    if (props.desk) {
        reportViewItem([
            {
                id: props.desk.mpn,
                name: props.desk.name,
                price: props.desk.price,
            },
        ]);
    }
});
</script>

<template>
    <AppHead v-if="desk" :title="desk.name" :description="desk.description" :image="desk.preset_image"></AppHead>
    <AppHead v-else title="3D Configurator voor standing desks"></AppHead>
    <teleport v-if="props.desk" to="head">
        <component :is="'script'" type="application/ld+json">
         {{ JSON.stringify(jsonLDObject) }}
        </component>
    </teleport>
    <website-layout>
        <Configurator
            :deskMaterials="deskMaterials"
            :frameMaterials="frameMaterials"
            :baseMaterialPrice="baseMaterialPrice"
            :deskControllerOptions="deskControllerOptions"
            :accessories="accessories"
            :desk="desk"
            :defaultSizes="defaultSizes"
        />
    </website-layout>
</template>
